import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const BirdIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                d='M13.471 14.2303L8.95514 9.7161C10.0201 7.00195 11.9693 4.64899 14.598 3.10291L14.6655 13.6264L13.471 14.2303ZM22.68 11.7261L21.1641 12.4302C20.7535 11.8855 20.1028 11.533 19.3688 11.533C18.3422 11.533 17.476 12.2211 17.2069 13.1614L13.2601 15.2127L1.67529 3.63268C0.364678 8.59948 1.81592 13.8552 5.38305 17.3943L5.37555 17.3962C4.7043 18.3533 3.52211 19.0762 1.79427 19.079C4.06208 21.4565 8.03979 21.2371 10.6011 19.933L22.212 13.2589C22.7474 12.9504 22.9517 12.2801 22.6798 11.7261L22.68 11.7261Z'
                fill='currentColor'
            />
        </>
    ),
})

BirdIcon.displayName = 'BirdIcon'
